import { render, staticRenderFns } from "./AppDataTable.vue?vue&type=template&id=8a992eb0&scoped=true&"
import script from "./AppDataTable.vue?vue&type=script&lang=js&"
export * from "./AppDataTable.vue?vue&type=script&lang=js&"
import style0 from "./AppDataTable.vue?vue&type=style&index=0&id=8a992eb0&prod&lang=scss&"
import style1 from "./AppDataTable.vue?vue&type=style&index=1&id=8a992eb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a992eb0",
  null
  
)

export default component.exports